var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6xsi6na2ka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.655 2.75h-9a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75h9a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75zm-.825.75L6.155 6.043 2.48 3.5h7.35zm-8.175 6V3.841L5.94 6.807a.375.375 0 0 0 .427 0l4.287-2.966V9.5h-9z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6xsi6na2ka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.155 .5)",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonEmail);
export default __webpack_public_path__ + "static/media/carbon_email.f02125518698ce49efca51e60bf85b01.svg";
export { ForwardRef as ReactComponent };